export function getBase64(file: any): Promise<string> {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      resolve(String(reader.result))
    };
    reader.onerror = function (error) {
      reject(error)
    };
  });
}